// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "", ""]);
// Exports
exports.locals = {
	"color1": "#72b1c8",
	"color2": "#0b1f2c",
	"color3": "#2c7898",
	"color4": "#d8d8d8",
	"color5": "#eb6852",
	"color6": "#622650",
	"color7": "#b092a7",
	"color8": "#3d3d3d",
	"highlighted1": "#a9cfdd",
	"highlighted2": "#1a4a69",
	"highlighted3": "#47a3ca",
	"highlighted4": "#fefefe",
	"highlighted5": "#f3a497",
	"highlighted6": "#993b7d",
	"highlighted7": "#d0becb",
	"highlighted8": "#636363",
	"hover1": "#2d6174",
	"hover2": "#000",
	"hover3": "#0a1a21",
	"hover4": "#8c8c8c",
	"hover5": "#932411",
	"hover6": "#000",
	"hover7": "#62475a",
	"hover8": "#000"
};
module.exports = exports;
